import React, { useState } from 'react';
import Input from 'shared/components/Input';
import Textarea from 'shared/components/Textarea';
import Button from 'shared/components/Button';
import { useTranslation } from 'react-i18next';
import { Api } from 'utils/connectors';
import PublicWrapper from 'shared/components/layout/PublicWrapper';

const initForm = {
  name: '',
  phone: '',
  from: '',
  subject: '',
  body: '',
};

const Contact = () => {
  const { t } = useTranslation();
  const [fetch, setFetch] = useState(false);
  const [error, setError] = useState();
  const [success, setSuccess] = useState('');
  const [form, setForm] = useState({ ...initForm });

  const onFormChange = ({ target }) => {
    const { name, value } = target;
    setForm({ ...form, [name]: value });
  };

  const onFormSubmit = async e => {
    setFetch(true);
    setError();
    e.preventDefault();
    try {
      const body = { ...form };
      await Api.post('/submit-contact-form', { body });
      setForm({ ...initForm });
      setSuccess('Message successfully sent');
      setTimeout(setSuccess, 5000, '');
    } catch (err) {
      setError(err.message);
      setFetch(false);
    }
  };

  return (
    <PublicWrapper>
      <div className='border-bottom flex-fill contact-page mt-md-8'>
        <div className='container'>
          <div className='d-flex flex-wrap'>
            <div className='col-md col-12 py-10 py-md-15 pb-20 pr-0 pr-md-16 pl-0'>
              <h2 className='mb-10'>{t('contact_title')}</h2>
              <p>{t('contact_sub_title')}</p>
              <form onSubmit={onFormSubmit}>
                <div className='row'>
                  <div className='col-12 col-md-6'>
                    <Input
                      type='text'
                      name='name'
                      onChange={onFormChange}
                      value={form.name}
                      label={t('ph_full_name')}
                      placeholder=''
                      required
                    />
                  </div>
                  <div className='col-12 col-md-6'>
                    <Input
                      type='text'
                      name='phone'
                      onChange={onFormChange}
                      value={form.phone}
                      label={t('ph_phone')}
                      placeholder=''
                      required
                    />
                  </div>
                  <div className='col-12 col-md-6'>
                    <Input
                      type='email'
                      name='from'
                      onChange={onFormChange}
                      value={form.from}
                      label={t('ph_email')}
                      placeholder=''
                      required
                    />
                  </div>
                  <div className='col-12 col-md-6'>
                    <Input
                      type='text'
                      name='subject'
                      onChange={onFormChange}
                      value={form.subject}
                      label={t('ph_subject')}
                      placeholder=''
                      required
                    />
                  </div>
                  <div className='col-12'>
                    <Textarea
                      name='body'
                      onChange={onFormChange}
                      value={form.body}
                      label={t('ph_message')}
                      placeholder=''
                      required
                    />
                  </div>
                </div>
                {error && <div className='d-block invalid-feedback mb-5 mt-0 text-right'>{error}</div>}
                {success && <div className='d-block text-success mb-5 mt-0 text-right'>{success}</div>}
                <div>
                  <Button type='submit' disabled={fetch} className='btn-primary'>
                    {t('btn_send')}
                  </Button>
                </div>
              </form>
            </div>
            <div className='col-md col-12 contact-info py-10 pb-38 py-md-15 px-0 px-md-15'>
              <h3 className='mb-15 pt-10 pt-md-0'>{t('contact_info_title')}</h3>
              <ul className='list-unstyled'>
                <li className='d-flex mb-7'>
                  <div className='col-3 p-0'>
                    <b>{t('text_name')}</b>
                  </div>
                  <div className='col pr-0 pl-2'>{t('contact_name')}</div>
                </li>
                <li className='d-flex mb-7'>
                  <div className='col-3 p-0'>
                    <b>{t('text_email')}</b>
                  </div>
                  <div className='col pr-0 pl-2'>{t('contact_email')}</div>
                </li>
                <li className='d-flex mb-7'>
                  <div className='col-3 p-0'>
                    <b>{t('text_address')}</b>
                  </div>
                  <div className='col pr-0 pl-2'>{t('contact_address')}</div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </PublicWrapper>
  );
};

export default Contact;
